/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lang_Name_DeInputs */

const en_lang_name_de = /** @type {(inputs: Lang_Name_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const de_lang_name_de = /** @type {(inputs: Lang_Name_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {Lang_Name_DeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lang_name_de = /** @type {((inputs?: Lang_Name_DeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lang_Name_DeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lang_name_de(inputs)
	return en_lang_name_de(inputs)
});